export class OperationCategoryConstant {
    static STATUS_AWAITING_ID = "AWAITING";
    static STATUS_IN_PROGRESS_ID = "IN_PROGRESS";
    static STATUS_COMPLETE_ID = "COMPLETE";
    static STATUS_ARCHIVED_ID = "ARCHIVED";
    static STATUS_AWAITING_MANIFESTE_ID = "AWAITING_MANIFESTE"
  
    static OPERATION_CATEGORY_OPTIONS = [
      { label: "En attente", value: this.STATUS_AWAITING_ID },
      { label: "En cours", value: this.STATUS_IN_PROGRESS_ID },
      { label: "Terminé", value: this.STATUS_COMPLETE_ID },
      { label: "Archivé", value: this.STATUS_ARCHIVED_ID },
      { label: "En attente de manifeste", value: this.STATUS_AWAITING_MANIFESTE_ID },
    ];
  }
  
  export const getOperationCategoryTag = (id: string) => {
    const option = OperationCategoryConstant.OPERATION_CATEGORY_OPTIONS.find(
      (opt) => opt.value === id
    );
    let color = "default";
    switch (id) {
      case OperationCategoryConstant.STATUS_AWAITING_ID:
        color = "gold";
        break;
      case OperationCategoryConstant.STATUS_IN_PROGRESS_ID:
        color = "blue";
        break;
      case OperationCategoryConstant.STATUS_COMPLETE_ID:
        color = "green";
        break;
      case OperationCategoryConstant.STATUS_AWAITING_MANIFESTE_ID:
        color = "volcano";
        break;
      case OperationCategoryConstant.STATUS_ARCHIVED_ID:
        color = "purple";
        break;
    }
    return { label: option?.label || id, color };
  };
  